import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/stores/authStore";
import { useDiaryStore } from "@/lib/stores/diaryStore";
import childrenDiaryIntroAudio from "@/assets/audios/children-diary-intro.m4a";
import childrenDiaryThermometerAudio from "@/assets/audios/children-diary-thermometer.m4a";
import Thermometer from "@/components/ui/thermometer";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/diary-children/"
)({
  component: () => <RouteComponent />,
  head: () => ({
    meta: [
      {
        title: "Writing a Diary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.diary",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { hasEntries, fetchEntries } = useDiaryStore();
  const [showThermometerView, setShowThermometerView] = useState(false);

  useEffect(() => {
    if (user) {
      fetchEntries().catch(console.error);
    }
  }, [user, fetchEntries]);

  const showArchiveButton = user && hasEntries();

  const displayThermometerView = () => {
    setShowThermometerView(true);
  };

  const handleViewArchive = () => {
    navigate({
      to: "/children/exercises/diary-children/archive",
      search: { saved: false },
    });
  };

  const startExercise = () => {
    navigate({ to: "/children/exercises/diary-children/exercise" });
  };

  return (
    <ExerciseLayout
      contentClassName="space-y-18 py-7.5 "
      actions={
        <>
          {!showThermometerView ? (
            <>
              <Button className="w-full" onClick={displayThermometerView}>
                <FormattedMessage id="common.next" />
              </Button>
              {showArchiveButton && (
                <Button
                  className="w-full"
                  variant="secondary"
                  onClick={handleViewArchive}
                >
                  <FormattedMessage id="diary.explanation.myDiaryArchive" />
                </Button>
              )}
            </>
          ) : (
            <Button className="w-full" onClick={startExercise}>
              <FormattedMessage id="positiveImagery.intro.start.button" />
            </Button>
          )}
        </>
      }
    >
      {showThermometerView && <DisabledThermometerView />}
      {!showThermometerView && (
        <>
          <p className="text-small">
            <FormattedMessage id="diary.children.intro.description" />
          </p>
          <MediaPlayer src={childrenDiaryIntroAudio} />
        </>
      )}
    </ExerciseLayout>
  );
}

function DisabledThermometerView() {
  return (
    <>
      <p className="text-small">
        <FormattedMessage id="diary.children.thermometer.description" />
      </p>
      <div className="px-4 flex flex-col">
        <Thermometer
          feeling={"happy"}
          onValueChange={() => {}}
          disabled={true}
        />
      </div>
      <MediaPlayer src={childrenDiaryThermometerAudio} />
    </>
  );
}
